function UniqueLead() {
  return (
    <div
      style={{
        background: "rgba(28, 76, 207, 0.16)",
        width: "56px",
        height: "56px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 100 100">
        <circle cx="50" cy="29" r="9" fill="#0933bd" />
        <path
          fill="#0933bd"
          d="M78 44H22c-2 0-2.8 2.5-1.1 3.6l14.6 9.4c.7.5 1.1 1.4.8 2.2l-5.5 18.3c-.6 2 2 3.4 3.5 1.9l14.2-15c.8-.9 2.2-.9 3 0l14.2 15c1.4 1.5 4 .1 3.5-1.9l-5.5-18.3c-.2-.8.1-1.7.8-2.2l14.6-9.4C80.8 46.5 80 44 78 44z"
        />
      </svg>
    </div>
  );
}

export default UniqueLead;
